import React from "react";
import { Row, Col } from "react-bootstrap";
import styles from "../../pages/NSF/Nsf.module.css";

const NSFHeader = ({ onSendNSFAlert }) => {
  return (
    <Row className="align-items-center mb-4">
      <Col md={8}>
        <h1 className={styles.nsfPageTitle}>NSF Borrower Notifications</h1>
      </Col>
    </Row>
  );
};

export default NSFHeader;
